var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C15.5523 0 16 0.447715 16 1V9C16 9.55229 15.5523 10 15 10H1C0.447715 10 0 9.55229 0 9V1C0 0.447715 0.447715 0 1 0H15ZM15 2.892L8 6.00406L1 2.892V9H15V2.892ZM15 1H1V1.798L8 4.90991L15 1.798V1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOutlined);
export default __webpack_public_path__ + "static/media/email-outlined.4ea85092.svg";
export { ForwardRef as ReactComponent };